import axios from 'axios';
import store from '../store';
import router from '../router';
import { LOCAL_STORAGE_KEY } from '@/utils/constants';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  maxRedirects: 0,
  withCredentials: true,
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status == 401 && !error.response.config.url.includes('verify_code')) {
      store.commit('auth/setLoggedOut');
      router.push('/login');
    }
    return Promise.reject(error);
  },
);

export default api;
